export const enumAuthTypes = Object.freeze({
    INPUT: "input",
    BUTTON: "button"
});